import React from "react";

const EditPrescription = () => {
  return <div></div>;
};

export default EditPrescription;
